import React, { Component } from 'react';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import {
  Container,
  Grid,
  Typography,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
import platformIfcViewer from '../../../../../media/platform-ifc-viewer.png';
import platformPdfViewer from '../../../../../media/platform-pdf-viewer.png';
import platformDocuments from '../../../../../media/platform-documents.png';
import platformEditeurRapport from '../../../../../media/platform-editeur-rapport.png';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const tabImages = [
  { src: platformIfcViewer, alt: 'Visualisation de maquettes BIM/IFC' },
  { src: platformPdfViewer, alt: 'Coupes et vues en plans' },
  { src: platformDocuments, alt: 'Gestion documentaire' },
  { src: platformEditeurRapport, alt: 'Gestion de tâches et rapports' },
];

export default function VisualisationAndControl() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="md" className="section">
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Typography variant='h2' components='h2' className="title">
            Visualisation et Contrôle
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 'auto', width: '100%' }}
          >
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Visualisation et contrôle"
              sx={{ borderRight: 1, borderColor: 'divider', minWidth: '280px' }}
            >
              <Tab className='lead' label="Visualisez un grand nombre de maquettes directement en ligne" {...a11yProps(0)} />
              <Tab className='lead' label="Possibilité de faire des coupes, d'avoir des vues en plans et de les exporter en .dxf ou .pdf" {...a11yProps(1)} />
              <Tab className='lead' label="Outils de cotation pour mesurer facilement les distances" {...a11yProps(2)} />
              <Tab className='lead' label="Outils de gestion de tâches" {...a11yProps(3)} />
            </Tabs>
            {tabImages.map((img, index) => (
              <TabPanel key={index} value={value} index={index}>
                <img src={img.src} alt={img.alt} style={{ width: '100%', borderRadius: '8px', boxShadow: '0 5px 20px rgba(0,0,0,0.1)' }} />
              </TabPanel>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Container >
  );
}
